module.exports = __webpack_public_path__ + "img/361.3e4d3ce5.png";